import React from "react";
import "./globalErrorBoundary.scss";
import Logo from "../../assets/PALAMOA_bl.svg";
import { Icon } from "react-icons-kit";
import { rotateCw as homeIcon } from "react-icons-kit/feather/";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, errorDetails: "", showDetails: false };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      console.log("Global Error Boundary:", error)
      try {
        if (error.hasOwnProperty("stack")) {
          this.setState({errorDetails: error.stack})
        } else{
          this.setState({errorDetails: error})
        }
      } catch (error) {
        console.log("Error Error :(")
      }
    }
  
    render() {
      if (this.state.hasError) {
        return <div class="globalErrorBoundaryWrapper">
          <div class="globalErrorBoundaryMessage mb-2">
            <img className="navbar-logo mb-2" src={Logo} height="24" alt="Palamoa Logo"/>
            <h1>:(</h1>
            <br/>
            <br/>
            <h2>Unfortunately something went wrong.</h2>
            <br/>
            <h2>Leider ist etwas schief gelaufen.</h2>
            <br/>
            <br/>
            <br/>
            <br/>
            <a href="/">
                <Icon size={30} icon={homeIcon} />
            </a>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <a onClick={()=> {this.setState({showDetails: !this.state.showDetails})}}>Details</a>
          </div>
          {this.state.showDetails && <textarea readOnly class="errorDetails" value={this.state.errorDetails}></textarea>}
        </div>
      }
  
      return this.props.children; 
    }
  }